import { useEffect, useState } from 'react';
import './App.css';
import { Routes, Route } from "react-router-dom";
import { FirebaseHelper } from './firebase-helper'
import HomePage from './views/HomePage/HomePage';
import AppIcon from './components/AppIcon/AppIcon';
import PostPage from './views/PostPage/PostPage';
import WallpapersPage from './views/WallpapersPage/WallpapersPage';
import PostsPage from './views/PostsPage/PostsPage';

function App() {
  const [posts, setPosts] = useState();
  const [wallpapers,setWallpapers] = useState(); 

  const firebaseHelperPosts = new FirebaseHelper("posts");
  const postsRef = firebaseHelperPosts.usersCollectionRef;

  const firebaseHelperWallpapers = new FirebaseHelper("wallpapers");
  const wallpapersRef = firebaseHelperWallpapers.usersCollectionRef;

  useEffect(() => {
    const getPosts = async () => {
      var posts = await FirebaseHelper.getAllDocs(postsRef);
      posts.sort(function(a, b) {
        var c = Date.parse(a.publishDate);
        var d = Date.parse(b.publishDate);
        return d-c;
      });
      setPosts(posts)
      setWallpapers(await FirebaseHelper.getAllDocs(wallpapersRef))
    }
    getPosts();
    console.log("App Started");
  },[])

  return (
    <div className="App">
      <AppIcon/>
      <Routes>
          <Route index element={posts&&wallpapers&&<HomePage posts={posts} wallpapers={wallpapers}/>} />
          <Route path='/wallpapers' element={<WallpapersPage/>} />
          <Route path='/reviews' element={<PostsPage/>} />
          <Route path='/post/:id' element={<PostPage/>} />
      </Routes>
      
    </div>
  );
}

export default App;
